module.exports = {
  "country": "AU",
  "artist": "Kate Miller-Heidke",
  "song": "Zero Gravity",
  "year": "2019",
  "place": "9",
  "spotify": "4m5FlWpaOri9OrDUj1EoTg"
};